import { FlexContainer } from '@taxdown/piccolo-web';
import styled from 'styled-components';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const Container = styled(FlexContainer)`
  padding: ${({ theme: { reference } }) => reference.dimension_24};
  background: ${({ theme: { colors } }) => colors.iridiscent_gradient};
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_M};
  margin-top: ${({ theme: { sizing }, isResult }) => isResult && sizing.fds_size_16};
  width: 450px;
  box-shadow: 0px 4px 4px 0px #00000040;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    width: auto;
  }
`;
